module.exports = __webpack_public_path__ + "static/media/result-bg.1ecd1e4d.jpg";